import { ConfirmCancelInput, TripOutput } from '@allocab/allocab-passenger-shared-types';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { mutationKeys } from '../services/datastore/mutationKeys';
import { queryKeys } from '../services/datastore/queryKeys';
import { passengerApi } from '../services/network/Api';
import { APIError } from '../services/network/types';

type Input = ConfirmCancelInput & { jwtToken: string };

const confirmAnonymousCancellation = ({ jwtToken, ...input }: Input) =>
  passengerApi.post<ConfirmCancelInput, TripOutput>('/anonymous/v1/trip/confirm-cancellation', input, {
    headers: { Authorization: `Bearer ${jwtToken}` },
  });

export const useConfirmAnonymousCancellation = (jwtToken: string) => {
  const queryClient = useQueryClient();
  const confirmAnonymousCancellationMutation = useMutation<TripOutput, APIError, ConfirmCancelInput>({
    mutationKey: mutationKeys.confirmAnonymousCancellation(jwtToken),
    mutationFn: (input: ConfirmCancelInput) => confirmAnonymousCancellation({ jwtToken, ...input }),
    onSuccess: trip => {
      queryClient.setQueryData(queryKeys.fetchAnonymousTrip(jwtToken), trip);
    },
  });

  return confirmAnonymousCancellationMutation;
};
